import * as yup from "yup";
import { portugues } from "_utils/validador";

yup.setLocale(portugues);

export function parseValorPago(valor: string | null | undefined): number {
  const centavos = String(valor ?? "").replace(/\D/g, "");
  return centavos ? Number(centavos) / 100 : 0;
}

export const baixaManualSchema = yup.object().shape({
  tipo: yup
    .string()
    .oneOf(["cancelado", "manual"], "Selecione uma opção")
    .required("Selecione uma opção"),
  observacao: yup.string().trim().required("A observação é obrigatória"),
  valorPago: yup
    .string()
    .nullable()
    .when("tipo", {
      is: "manual",
      then: (schema) =>
        schema.test(
          "valor-obrigatorio",
          "Informe um valor válido",
          (value) => parseValorPago(value) > 0,
        ),
      otherwise: (schema) => schema.optional(),
    }),
  dataPagamento: yup
    .mixed<Date>()
    .nullable()
    .when("tipo", {
      is: "manual",
      then: (schema) =>
        schema
          .required("A data de pagamento é obrigatória")
          .test(
            "nao-futura",
            "A data de pagamento não pode ser futura",
            (value) => {
              if (!value) return false;
              const hoje = new Date();
              hoje.setHours(23, 59, 59, 999);
              return value <= hoje;
            },
          ),
      otherwise: (schema) => schema.optional(),
    }),
  comprovante: yup
    .mixed<File>()
    .nullable()
    .when("tipo", {
      is: "manual",
      then: (schema) =>
        schema.test(
          "comprovante-obrigatorio",
          "O comprovante é obrigatório",
          (value) => value instanceof File && value.size > 0,
        ),
      otherwise: (schema) => schema.optional(),
    }),
});

export interface BaixaManualForm {
  tipo: "cancelado" | "manual";
  observacao: string;
  valorPago: string | null | undefined;
  dataPagamento: Date | null | undefined;
  comprovante: File | null | undefined;
}
